import {controller} from '@github/catalyst'

@controller
class GlobalBannerElement extends HTMLElement {
  connectedCallback() {
    if (this.hidden) return
    const disabledBanners = this.getCookie('disabled_global_site_banners')?.split(',') || []
    if (disabledBanners.includes(this.id)) this.hidden = true
  }

  close() {
    this.hidden = true
    this.updateCookie()
  }

  getCookie(name: string) {
    const matches = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}\\s*=\\s*([^;]+)`))
    return matches ? matches[1] : null
  }

  cookieExpiration(days: number) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3)
    return date.toUTCString()
  }

  setCookie(name: string, value: string, days: number) {
    document.cookie = `${name}=${value}; path=/; expires=${this.cookieExpiration(days)}`
  }

  updateCookie(cookieName: string = 'disabled_global_site_banners', cookieExpirationDays: number = 30) {
    const existingCookie = this.getCookie(cookieName)
    if (existingCookie) {
      const cookieValue = existingCookie
        .split(',')
        .filter(id => id !== this.id)
        .join(',')
      this.setCookie('disabled_global_site_banners', `${cookieValue},${this.id}`, cookieExpirationDays)
      return
    }
    this.setCookie('disabled_global_site_banners', this.id, cookieExpirationDays)
  }
}
